<template>
    <div>
        <svg v-if="active" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width"
             :height="height" viewBox="0 0 29 21">
            <defs>
                <linearGradient id="linear-gradient" x1="0.5" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                    <stop offset="0" stop-color="#3266f5"/>
                    <stop offset="1" stop-color="#e21851"/>
                </linearGradient>
            </defs>
            <g id="menu" transform="translate(-316 -762)">
                <path id="Exclusion_14" data-name="Exclusion 14"
                      d="M26.5,5H2.5a2.5,2.5,0,1,1,0-5h24a2.5,2.5,0,0,1,0,5ZM2.407,1a1.5,1.5,0,1,0,0,3H26.594a1.5,1.5,0,0,0,0-3Z"
                      transform="translate(316 762)" fill="url(#linear-gradient)"/>
                <path id="Exclusion_15" data-name="Exclusion 15"
                      d="M26.5,5H2.5a2.5,2.5,0,1,1,0-5h24a2.5,2.5,0,0,1,0,5ZM2.407,1a1.5,1.5,0,1,0,0,3H26.594a1.5,1.5,0,0,0,0-3Z"
                      transform="translate(316 770)" fill="url(#linear-gradient)"/>
                <path id="Exclusion_16" data-name="Exclusion 16"
                      d="M26.5,5H2.5a2.5,2.5,0,1,1,0-5h24a2.5,2.5,0,0,1,0,5ZM2.407,1a1.5,1.5,0,1,0,0,3H26.594a1.5,1.5,0,0,0,0-3Z"
                      transform="translate(316 778)" fill="url(#linear-gradient)"/>
            </g>
        </svg>

        <svg v-else xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 29 21">
            <g id="Group_2836" data-name="Group 2836" transform="translate(-316 -762)">
                <path id="Exclusion_14" data-name="Exclusion 14"
                      d="M26.5,5H2.5a2.5,2.5,0,1,1,0-5h24a2.5,2.5,0,0,1,0,5ZM2.407,1a1.5,1.5,0,1,0,0,3H26.594a1.5,1.5,0,0,0,0-3Z"
                      transform="translate(316 762)" fill="#3266f5"/>
                <path id="Exclusion_15" data-name="Exclusion 15"
                      d="M26.5,5H2.5a2.5,2.5,0,1,1,0-5h24a2.5,2.5,0,0,1,0,5ZM2.407,1a1.5,1.5,0,1,0,0,3H26.594a1.5,1.5,0,0,0,0-3Z"
                      transform="translate(316 770)" fill="#3266f5"/>
                <path id="Exclusion_16" data-name="Exclusion 16"
                      d="M26.5,5H2.5a2.5,2.5,0,1,1,0-5h24a2.5,2.5,0,0,1,0,5ZM2.407,1a1.5,1.5,0,1,0,0,3H26.594a1.5,1.5,0,0,0,0-3Z"
                      transform="translate(316 778)" fill="#3266f5"/>
            </g>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "IMenu",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            },
            active: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>
